import { useTracking } from '#imports'

export type JoinNowPlacement = 'site-nav' | 'footer'

/** Footer links are brand config, so a Join Now link is recognised by the signup query it opens. */
export function isSignupHref(href: string | undefined): boolean {
    const query = href?.split('?')[1]?.split('#')[0]
    if (!query) return false

    return new URLSearchParams(query).get('auth') === 'signup'
}

/**
 * `join-now_click`: which Join Now opened signup, so signups closed on step 1 can be
 * traced back to the button that opened them. `useTracking` stamps the route.
 */
export function trackJoinNowClick(placement: JoinNowPlacement) {
    const { trackEvent } = useTracking()

    trackEvent({
        event_name: 'join-now_click',
        event_type: 'Click',
        meta_data: [{ category: 'Signup', placement }],
    })
}
